var _style, _g, _path, _path2, _path3, _path4, _path5, _defs, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIceCream({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BAD1C1;}\n\t.st1{fill:#5FA9DE;}\n\t.st2{fill:#3B89C4;}\n\t.st3{fill:#B92555;}\n\t.st4{fill:#FFE9B7;}\n\t.st5{fill:#8B4C39;}\n\t.st6{clip-path:url(#SVGID_2_);fill:#3B89C4;}\n\t.st7{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.37,138.83c0,0,30.13-7.7,37.75-36.47c1.12-4.22-4.29-7.69-10.93-7.69H72.81c-3.32,0-10.57,1.39-8.68,8.18 c7.87,28.28,36.94,35.98,36.94,35.98v3.31c0,0-13.1,6.91-15.79,8.51c-2.9,1.66-0.75,4.31,0.41,4.77c1.93,0.76,6.75,3.25,20.11,3.25 c13.7,0,21.19-2.7,22.85-3.25c0.64-0.21,3.38-2.75-0.56-5.08c-7.02-4.15-15.7-8.19-15.7-8.19V138.83z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M149.94,101.02c0,4.78-19.32,8.66-43.15,8.66c-23.83,0-43.15-3.88-43.15-8.66c0-4.78,19.32-8.66,43.15-8.66 C130.62,92.36,149.94,96.24,149.94,101.02"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M129.28,76.12c0,5.01-8.85,14.74-22.13,14.74c-12.22,0-22.13-6.49-22.13-14.74c0-13.44,9.91-21.09,22.13-21.09 C119.37,55.04,129.28,62.69,129.28,76.12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M149.94,98.11c0,4.56-8.85,11.94-22.13,11.94c-12.23,0-22.14,3.94-22.14-11.94 c0.14-12.22,10.16-22.02,22.38-21.88C140.08,76.36,149.8,86.08,149.94,98.11"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M108.62,98.11c0,14.65-8.85,12.18-22.13,12.18c-12.22,0-22.13-4.67-22.13-12.18c0-12.22,9.91-22.13,22.13-22.13 C98.71,75.98,108.62,85.89,108.62,98.11C108.62,98.11,108.62,98.11,108.62,98.11"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M109.31,94.67H72.8c-3.32,0-10.57,1.39-8.68,8.18c7.86,28.28,36.94,35.98,36.94,35.98v3.32 c0,0-13.1,6.91-15.79,8.51c-2.9,1.66-0.75,4.31,0.41,4.77c1.93,0.76,6.75,3.25,20.11,3.25c13.7,0,21.19-2.7,22.85-3.25 c0.64-0.21,3.38-2.75-0.56-5.08c-7.02-4.15-15.7-8.19-15.7-8.19v-3.32c0,0,30.13-7.7,37.75-36.48c1.12-4.22-4.3-7.68-10.93-7.68 H109.31z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M63.62,106.61c5.41,1.72,45.74,14.88,88.41-1.48c0.25,2.34-0.62,10.58-4.06,11.19 c-3.44,0.61-40.22,12.71-81.29-0.57C65.57,114.52,63.62,106.61,63.62,106.61"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.87,100.82c3.95,1.7,43.77,14.26,86.19,0.25c0,1.85-1.16,7-1.85,8.98c-1.1,3.2-43.53,13.65-81.64,0.74 C65.46,110.29,62.15,100.09,63.87,100.82"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M76.75,119.26c0,0-0.19,0.13-0.45,0.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceCream);
export default __webpack_public_path__ + "static/media/Ice_cream.4b88503faa6e60e54d4bb8bea8cf956c.svg";
export { ForwardRef as ReactComponent };